import React from "react";
import { Snackbar, Alert } from "@mui/material";

const AlertToast = ({
  open,
  message,
  type = "success",
  time = 3000,
  autoHide = true,
  onClose,
  ...props
}) => {
  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    if (onClose) onClose();
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHide ? time : null}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      {...props}
    >
      <Alert
        onClose={handleClose}
        severity={type}
        variant="filled"
        sx={{ width: "100%", borderRadius: 3 }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default AlertToast;
